import React, { useEffect, useMemo, useState } from "react";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import { Box, TableCell, TableRow } from "@mui/material";
import useStyles from "../../../../components/pageTitle/styles";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import dayjs from "dayjs";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import { getJobCompletionTaskAction } from "../../../../store/reducers/reviewSlice";
interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  status: string;
  leadId?: string;
}

const LeadTask = ({ activeQuoteId }: { activeQuoteId?: any }) => {
  const classes = useStyles();

  const { leadDetails } = useSelector((state: any) => state.lead);
  const { userProfile } = useSelector((state: any) => state?.user);
  const { jobCompletionTasks } = useSelector((state: any) => state.review);
  const dispatch = useDispatch();

  const [filterOption, setFilterOption] = React.useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "",
    orderIn: "asc",
    status: "",
    leadId: leadDetails?.lead?.generated_id || "",
  });

  const tableHeadings: TableHeading[] = [
    { label: "Service", align: "left" },
    { label: "Date", align: "left" },
    { label: "Crew", align: "left" },
    { label: "Status", align: "left" },
  ];

  useEffect(() => {
    dispatch(
      getJobCompletionTaskAction({ leadId: leadDetails?.lead?.generated_id }),
    );
  }, []);

  //  useEffect(() => {
  //   if (filterOption.leadId) {
  //     dispatch(getJobCompletionTaskAction({leadId:leadDetails?.lead?.generated_id}));
  //   }
  // }, [filterOption]);

  return (
    <>
      <PageTitle title={"Task on this lead"} />
      <Box
        sx={{
          bgcolor: "#fff",
          height: { xs: "auto" },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          padding: "0px",
          overflow: "hidden",
        }}
      >
        <TableDesign
          tableHeadings={tableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={jobCompletionTasks?.length > 0 ? null : null}
          isLoader={false}
          filterOption={filterOption}
          stickyHeader={true}
          setFilterOption={setFilterOption}
          //   extraCSS={{
          //     height: "calc(100%)",
          //   }}
        >
          {jobCompletionTasks?.length > 0 ? (
            jobCompletionTasks?.map((val: any, idx: number) => (
              <TableRow
                key={val?.complaint_id}
                sx={{
                  cursor: "pointer",
                  marginTop: "0px",
                  padding: "4px !important",
                  borderRadius: "20px !important",
                  height: "20px !important",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                    outline: "2px solid #f0f0f0",
                    borderRadius: "0px !important",
                    outlineOffset: "-2px !important",
                  },
                }}
              >
                <TableCell>{val?.job_title}</TableCell>
                <TableCell>
                  {val?.start_date_time
                    ? dayjs(val.start_date_time).format(
                        userProfile?.dateFormat || "DD/MM/YYYY",
                      )
                    : "N/A"}
                </TableCell>

                <TableCell
                  width={"300px"}
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {val?.crews && val?.crews?.length > 0
                    ? val?.crews
                        ?.map((crew: any) => crew?.name)
                        .join(", ")
                    : "N/A"}
                </TableCell>
                <TableCell>{val?.status}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={tableHeadings?.length} align="center">
                <Box
                  sx={{
                    height: "20vh",
                    display: "flex",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      fontSize: "1rem",
                      color: "#4A4A4A",
                      alignSelf: "center",
                    }}
                  >
                    {`No Data Found!`}
                  </span>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>
    </>
  );
};

export default LeadTask;
